import React from 'react';
import { LinearProgress } from '@mui/material';

import { ArcProgressBarProps, ArcProgressBarVariantProps } from './types';

// `#275028` (default battery fill) is too dark to be visible on a gray track —
// it only works in ArcBatteryLife because a white SVG border surrounds it.
// Use success.main (#66bb6a) which is the theme's proper bright green.

const ArcProgressBar: React.FC<ArcProgressBarProps> & ArcProgressBarVariantProps = (props) => {
  return (
    <LinearProgress 
      sx={{ 
        height: 6, 
        borderRadius: '2px', 
        backgroundColor: 'background.paper' 
      }} 
      {...props} />
  );
};

ArcProgressBar.success = (props) => (
  <ArcProgressBar color='success' variant='determinate' {...props} />
);

ArcProgressBar.brand = (props) => (
  <ArcProgressBar
    variant="determinate"
    {...props}
    sx={{
      '&&': {
        backgroundColor: 'ghost.main', 
      },
      '& .MuiLinearProgress-bar': {
        backgroundColor: 'brand.main',
      }  ,
      ...props.sx,   
    }}
    
  />
);

ArcProgressBar.mission = (props) => (
  <LinearProgress
    color='success'
    variant="determinate"
    {...props}
    sx={{
      height: 6,
      borderRadius: '2px',
      '&&': { backgroundColor: 'ghost.main' },
      ...props.sx,
    }}
  />
);

function ArcProgressBarCondition(props: ArcProgressBarProps) {
  const barColor =
    props.value != null && props.value > 66
      ? 'error.main'
      : props.value != null && props.value > 33
        ? 'warning.main'
        : 'success.main';
  return (
    <ArcProgressBar
      variant="determinate"
      {...props}
      sx={{
        '&&': {
          backgroundColor: '#FFFFFF14',
        },
        '& .MuiLinearProgress-bar': {
          backgroundColor: barColor,
        },
        height: '8px',
        borderRadius: '4px',
        ...props.sx,
      }}
    />
  );
}

ArcProgressBar.condition = ArcProgressBarCondition;

export default ArcProgressBar;